import { IssuesOrderBy } from "@facade/services";
import { createContext } from "react";

export type IssueListMode = "issues" | "drafts";

export interface IssueListContextState {
  totalIssuesCount: number;
  orderBy: IssuesOrderBy;
  mode: IssueListMode;
  selectedIssueIds: ReadonlySet<string>;
  updateIssuesCount: (count: number) => void;
  updateOrderBy: (orderBy: IssuesOrderBy) => void;
  updateMode: (mode: IssueListMode) => void;
  updateIssueSelection: (issueId: string, selected: boolean) => void;
  clearIssueSelection: () => void;
}

export const IssueListContext = createContext<IssueListContextState>({
  totalIssuesCount: 0,
  orderBy: "newest",
  mode: "issues",
  selectedIssueIds: new Set(),
  updateIssuesCount: () => {
    return;
  },
  updateOrderBy: () => {
    return;
  },
  updateMode: () => {
    return;
  },
  updateIssueSelection: () => {
    return;
  },
  clearIssueSelection: () => {
    return;
  },
});
